module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/project/snsina/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main